/**
 * NF-958: Controller for managing notifications if type is
 */

/**
 * @class SimpleDialogController
 * Initializes a new instance of the SimpleDialogController.
 */
function SimpleDialogController() {
    // Initialize the controller
    this.init.apply(this, arguments);
}

// Dependency injection for the controller
SimpleDialogController.$inject = ['NotificationService', '$message', '$Loading', '$translationService', '$filter'];


SimpleDialogController.prototype = {
    /** @type {string} title */
    title: '',

    /** @type {string} body */
    body: '',

    /**
     * @type {NotificationModel} notification
     */
    notification: {},
    /**
     * Initializes the controller with necessary services and scope.
     * @param {NotificationService} NotificationService
     * @param {$message} $message
     * @param {$Loading} $Loading
     * @param {$translationService} $translationService
     * @param {$filter} $filter
     */
    init: function (NotificationService, $message, $Loading, $translationService, $filter) {
        this.notificationService = NotificationService;
        this.$message = $message;
        this.$Loading = $Loading;
        this.$translationService = $translationService;
        this.$filter = $filter;


        let keyValueData = JSON.parse(this.notification.KeyValueData || '{}');
        let chargingPoint = keyValueData.ChargingPoint || this.notification.ChargingPoint;
        let vehicle = keyValueData.Vehicle || this.notification.Vehicle;

        // from NF-127: Some items have been translate on server so we dont need to taking care of it
        this.title = this.notification.Subject;
        this.body = this.notification.Message;

        switch (this.notification.Type) {
            case 'ConnectToChargingPointCancelledChargingPointOffline':  //NF-958
                // this.title = this.$translationService.formatTranslation('ChargingPointOutOfService');                
                this.body = this.$translationService.formatTranslation('ChargingPointDetailedOutOfService', chargingPoint, vehicle);
                break;
            case 'ConnectToChargingPointCancelledChargingPointNotAccessible':  //NF-958
                // this.title = this.$translationService.formatTranslation('ChargingPointTemporarilyUnavailable');
                this.body = this.$translationService.formatTranslation('ChargingPointDetailedTemporarilyUnavailable', chargingPoint, vehicle);
                break;
            case 'ChargeInterruptedChargingPointOffline'://NF-964
                // this.title = this.$translationService.formatTranslation('YourChargeInterrupted');
                this.body = this.$translationService.formatTranslation('ChargingInterruptedDueToShutdown', vehicle, chargingPoint);
                break;
            case 'OfflineChargingPointUnassignedFromChargeBooking': //NF-965
                // this.title = this.$translationService.formatTranslation('ChargingPointOutOfService');
                this.body = this.$translationService.formatTranslation('AssignedChargingPointOutOfService', chargingPoint, vehicle);
                break;

            // from NF-127: translation have done on server with enough information
            // case 'ChargeHasEnded':
            //     this.title = this.$translationService.formatTranslation('YourChargeIsFinished');
            //     let date = this.$filter('formatDateLocal')(this.notification.EndDate);
            //     let time = this.$filter('formatTimeLocal')(this.notification.EndDate);
            //     this.body = this.$translationService.formatTranslation('ChargeHasEnded', vehicle, date, time, chargingPoint);
            //     break;

            // NF-1173: CancelReleaseChargingPoint
            // case 'CancelReleaseChargingPoint':
            //     // Request to release the charging point cancelled
            //     this.title = this.$translationService.formatTranslation('RequestToReleaseChargingPointCancelled');

            //     // The request to move your vehicle from charging point {0} has been cancelled. \n\nNo further action is needed.
            //     this.body = this.$translationService.formatTranslation('RequestToReleaseChargingPointCancelledBody', chargingPoint);
            //     break;

            // NF-1173: CancelConnectToChargingPoint
            // case 'CancelConnectToChargingPoint':
            //     // Request to connect the charging point cancelled
            //     this.title = this.$translationService.formatTranslation('RequestToConnectChargingPointCancelled');

            //     // The request to connect your vehicle to charging point {0} has been cancelled. \n\nDon't worry, you're back in the queue.
            //     this.body = this.$translationService.formatTranslation('RequestToConnectChargingPointCancelledBody', chargingPoint);
            //     break;   

            // case 'ChargeRequestCancelled': // NF-1173: when admin disconnect pending connection request
            //     this.title = this.$translationService.formatTranslation('NotificationSubject_ChargeRequestCancelled');
            //     this.body = this.$translationService.formatTranslation('NotificationMessage_ChargeRequestCancelled', keyValueData.DocumentType);
            //     break;

            // default:
            //     this.title = this.notification.Title;
            //     this.body = this.notification.Message;
            //     break;

        }
    },


    /**
     * Make a new charge request
     * @returns {angular.IPromise<void>}
     */
    ok: function () {
        // Once the charging point is marked as free, mark the notification as read
        this.notificationService.markAsRead(this.notification.Id)
            .then(() => {
                this.close();
            }, this.$message.error) // Handle error for marking notification as read
            .finally(this.$Loading.blockUI());
    }
};


// Register  controller with the AngularJS module
angular.module('internal.notifications').controller('SimpleDialogController', SimpleDialogController);